export const BIG_WIDTH = '1100px'
export const MEDIUM_WIDTH = '970px'
export const SMALL_WIDTH = '780px'
export const VERY_SMALL_WIDTH = '360px'
